import { Navigate, Outlet } from 'react-router-dom'

import navigateToNextOnboardingPageAction from '@actions/navigateToNextOnboardingPageAction'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'
import Accountablepage from './Accountablepage'
import CommitTrainingPage from './CommitTraining'
import InjuriesPage from './InjuriesPage'
import IntensityPreferencePage from './IntensityPreferencePage'
import OffToStartPage from './OffToStartPage'
import OnboardingCompletionPage from './OnboardingCompletionPage'
import OneSessionTimePage from './OneSessionTime'
import OtherActivitiesPage from './OtherActivities'
import RevealPlanPage from './RevealPlanPage'
import RunningExperiencePage from './RunningExperiencePage'
import RunPreferencePage from './RunPreference'
import SelectMarathonQuestionPage from './SelectMarathonQuestionPage'
import SpecificEventPage from './SpecificEventPage'
import UsuallyRunPage from './UsuallyRunPage'
import WhyChooseRunBabyRunPage from './WhyChooseRunBabyRunPage'

const onboardingRoutes = [
  {
    path: '/onboarding',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      {
        element: <Navigate to="running-experience" replace />,
        index: true,
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <RunningExperiencePage />,
        path: 'running-experience',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <CommitTrainingPage />,
        path: 'commit-training',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <OtherActivitiesPage />,
        path: 'other-activities',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <OneSessionTimePage />,
        path: 'one-session-time',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <RunPreferencePage />,
        path: 'run-preference',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <InjuriesPage />,
        path: 'injuries',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <IntensityPreferencePage />,
        path: 'intensity-preference',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SpecificEventPage />,
        path: 'specific-event',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SelectMarathonQuestionPage />,
        path: 'select-marathon',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <RevealPlanPage />,
        path: 'reveal-plan',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <WhyChooseRunBabyRunPage />,
        path: 'why-choose-run-baby-run',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <UsuallyRunPage />,
        path: 'usually-run',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <OffToStartPage />,
        path: 'off-to-start',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <Accountablepage />,
        path: 'accountable',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <OnboardingCompletionPage />,
        path: 'onboarding-completion',
      },
    ],
  },
]

export default onboardingRoutes
